import {AccountMenuColor, MenuColor} from '@containers/accountStyle/types'

// Keep in sync with track: src/main/webapp/css/menu-theme.css
export const ACCOUNT_MENU_PALETTE: Record<AccountMenuColor, string> = {
	RED: '#a8323e',
	BLUE: '#1f6f8b',
	DARK_GREY: '#3a3f47',
	GREEN: '#2f7a55',
	GREY: '#5b6670',
	ORANGE: '#b8582c',
	PINK: '#9c4a86',
	SOFT_GREY: '#7d8791',
	VIOLET: '#77417a',
	YELLOW: '#a8801f',
}

export interface PickerMenuColor {
	// Preset name or the #rrggbb that gets saved.
	value: MenuColor
	hex: string
	label: string
}

const preset = (color: AccountMenuColor): PickerMenuColor =>
	({value: color, hex: ACCOUNT_MENU_PALETTE[color], label: color})

// Extra ready-made colours are saved as a plain #rrggbb like a custom one: track-api and the legacy
// menu-theme.css already handle custom colours, so no new preset name is needed there.
const extra = (hex: string, label: string): PickerMenuColor => ({value: hex, hex, label})

// The user picker, sorted by hue: reds through violets to blues, then teal, greens and the warm
// browns, and the greys last. The ones added with the browns carry white text at 4.5:1 on their
// own; a few older ones fall a little short and get darkened a touch where it matters
// (see fitSignInAccent).
// Not offered any more, but kept in the palette for anyone who already has them: ORANGE (gave way to
// the custom colour), YELLOW and SOFT_GREY, and the plain GREEN, replaced by a darker teal-green.
// GREEN keeps its value: it mirrors menu-theme.css and the account colours set by admins.
export const PICKER_MENU_COLORS: PickerMenuColor[] = [
	preset('RED'),
	extra('#a3284f', 'RASPBERRY'),
	preset('PINK'),
	preset('VIOLET'),
	extra('#5e35b1', 'PURPLE'),
	extra('#3949ab', 'INDIGO'),
	extra('#1f3f6e', 'NIGHT_BLUE'),
	extra('#2459a8', 'COBALT'),
	extra('#455a72', 'SLATE'),
	preset('BLUE'),
	extra('#0e6f7e', 'SEA'),
	extra('#0f7c7a', 'TEAL'),
	extra('#0b755f', 'DARK_TEAL'),
	extra('#2e6b34', 'FOREST'),
	extra('#58661a', 'OLIVE'),
	extra('#85570f', 'AMBER'),
	extra('#6d4c41', 'BROWN'),
	extra('#a3452a', 'TERRACOTTA'),
	preset('GREY'),
	preset('DARK_GREY'),
]

export const DEFAULT_ACCOUNT_MENU_COLOR: AccountMenuColor = 'VIOLET'

export const DEFAULT_CUSTOM_MENU_COLOR = '#3a7bd5'
